class StripeDisplay {
    constructor(el) {
        this._init(el)
    }
    _init(el) {
        this.el = el
        if(!this.el) {
            return
        }
        this.elKey = document.getElementById('publishable_key')
        this.el.method = this;
        // this.elKey.checkoutStripe = this
        this.el.paymentID = 100
        this.stripe = Stripe(this.elKey.value, {
            betas: ['payment_intent_beta_3']
        })
        this.elements = this.stripe.elements()
        this.elementStyles = {
            base: {
                color: '#000',
                fontWeight: 400,
                fontFamily: 'Lato, sans-serif',
                fontSize: '14px',
                fontSmoothing: 'antialiased',

                ':focus': {
                    color: '#000',
                },

                '::placeholder': {
                    color: 'rgba(0,0,0,0.5)',
                },

                ':focus::placeholder': {
                    color: '#000',
                },
            },
            invalid: {
                color: '#FA755A',
                ':focus': {
                    color: '#FA755A',
                },
                '::placeholder': {
                    color: '#FFCCA5',
                },
            },
        }
        this.elementClasses = {
            base: 'stripe-card',
            focus: 'stripe-card--focus',
            invalid: 'stripe-card--error'
        }
        this.cardElement = this.elements.create('card', {
            style: this.elementStyles,
            classes: this.elementClasses,
        })
        this.cardElement.mount('#card-element')

        this.displayError = document.querySelector('[data-card-errors]')
        this.cardElement.addEventListener('change', this.errorHandler.bind(this.displayError))

        let fetched

        if(fetched = document.querySelector('[data-payment-fetch]')) {
            this.fetchURL = fetched.dataset.paymentFetch
        }

    }
    errorHandler(event) {
        if (event.error) {
            this.textContent = event.error.message
        } else {
            this.textContent = ''
        }
    }

    getSource() {
        const total = Array.from(document.querySelectorAll('[data-value-2]')).reduce((accumulator, currentValue) => {
            return parseFloat(currentValue.dataset.value) + accumulator
        }, 0)
        const totalInt = Math.round(total * 100)
        return new Promise((resolve, reject) => {
            const result = totalInt
            this.stripe.createSource(this.cardElement, {
                type: 'card',
                amount: result,
                currency: document.querySelector('[data-currency]').getAttribute('data-currency'),
                owner: {
                    name: document.querySelector('[data-name]').value,
                    email: document.querySelector('[data-email]').value,
                }
            }).then((result) => {
                if (result.error) {
                    // this.displayError.textContent = result.error.message
                    return reject(result.error)
                } else {
                    document.querySelector('[data-payment-source]').value = result.source.id
                    return resolve(result)
                }
            })
        })

        // return fetch(window.location.origin + this.fetchURL, {
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json',
        //     }
        // }).then(result => result.json())
        //     .then(result => new Promise((resolve, reject) => {
        //         // result = Math.round(parseFloat(result['total']) * 100)

        //         // // let _amount = result['result']
        //         // let _amount = Math.round(parseFloat(document.querySelector('[data-result]').getAttribute('data-result')) * 100)

        //         // if(_amount != result) {
        //         //     throw new Error('Invalid Amount was set for this. Please restart and try again.')
        //         // }

        //         const result = total * 100

        //         this.stripe.createSource(this.cardElement, {
        //             type: 'card',
        //             amount: result,
        //             currency: document.querySelector('[data-currency]').getAttribute('data-currency'),
        //             owner: {
        //                 name: document.querySelector('[data-name]').value,
        //                 email: document.querySelector('[data-email]').value,
        //             }
        //         }).then((result) => {
        //             if (result.error) {
        //                 // this.displayError.textContent = result.error.message
        //                 return reject(result.error)
        //             } else {
        //                 document.querySelector('[data-payment-source]').value = result.source.id
        //                 return resolve(result)
        //             }
        //         })
        //     }).catch(error => {
        //         this.displayError.textContent = error.message
        //         return reject(error)
        //     }))
    }
}

export default StripeDisplay